import { handleInput } from '../../utils';

export const hasFormErrors = (values = {}, ignore = []) => {
  const keys = Object.keys(values);
  return keys.some((key) => {
    if (ignore.some((ig) => ig === key)) {
      return false;
    }
    return !!values[key].errors;
  });
};

export const validateProviderInfo = (provider = {}, options = {}) => {
  return {
    name: handleInput(provider.name, options).required(),
    phone: handleInput(provider.phone, options).phoneMask().required(),
    phoneExt: handleInput(provider.phoneExt, options).onlyNumbers(),
    tollFreePhone: handleInput(provider.tollFreePhone, options).phoneMask(),
    tollFreePhoneExt: handleInput(provider.tollFreePhoneExt, options).onlyNumbers(),
    fax: handleInput(provider.fax, options).phoneMask(),
    streetAddress: handleInput(provider.streetAddress, options).required(),
    houseNumber: handleInput(provider.houseNumber, options),
    country: handleInput(provider.country, options).required(),
    city: handleInput(provider.city, options).required(),
    state: handleInput(provider.state, options).required(),
    zipCode: handleInput(provider.zipCode, options).zip(provider.country).required(),
    mailStreetAddress: handleInput(provider.mailStreetAddress, options).required(),
    mailHouseNumber: handleInput(provider.mailHouseNumber, options),
    mailCountry: handleInput(provider.mailCountry, options).required(),
    mailCity: handleInput(provider.mailCity, options).required(),
    mailState: handleInput(provider.mailState, options).required(),
    mailZipCode: handleInput(provider.mailZipCode, options).zip(provider.mailCountry).required(),
    registrationPhone: handleInput(provider.registrationPhone, options).phoneMask(),
    courseRegistrationWebsite: handleInput(provider.courseRegistrationWebsite, options).website(),
    companyWebsite: handleInput(provider.companyWebsite, options).website(),
  };
};

export const validateUserInfo = (user, options = {}) => {
  return {
    firstName: handleInput(user.firstName, options).required(),
    lastName: handleInput(user.lastName, options).required(),
    email: handleInput(user.email, options).email().required(),
    phone: handleInput(user.phone, options).phoneMask().required(),
    username: handleInput(user.username, options).required().min(4),
    password: handleInput(user.password, options).required().complexPassword(),
    confirmPassword: handleInput(user.confirmPassword, options).required().sameValue(user.password),
  };
};



// WEBPACK FOOTER //
// ./src/components/SignUpForm/schema.js